// On document ready:
document.addEventListener('DOMContentLoaded', function () {
    // NOTE: This script will be loaded on every page AND in the Gutenberg editor.

    // Luister naar veranderingen op checkboxes binnen het veld met jouw class
    jQuery(document).on('change', '.max-three-checkboxes input[type="checkbox"]', function () {

        // Zoek het hoofdveld op (de container van de checkboxes)
        var $container = jQuery(this).closest('.gfield');

        // Tel het aantal aangevinkte checkboxes binnen deze container
        var checkedCount = $container.find('input[type="checkbox"]:checked').length;

        // Als het er meer dan 3 zijn...
        if (checkedCount > 3) {
            jQuery(this).prop('checked', false); // ...haal het zojuist gezette vinkje weer weg
            alert("Je mag maximaal 3 thema's selecteren.");
        }
    });
});